import { useState, useEffect } from 'react';
import { fetchPriceGroupOptions, fetchMemberTypeNames } from '../api/manageItems';

export const useManageOptions = () => {
  const [priceGroupOptions, setPriceGroupOptions] = useState([]);
  const [memberTypeNames, setMemberTypeNames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    Promise.all([fetchPriceGroupOptions(), fetchMemberTypeNames()])
      .then(([prices, members]) => {
        if (!ignore) {
          setPriceGroupOptions(prices || []);
          setMemberTypeNames(members || []);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!ignore) {
          console.error('Failed to load manage options', err);
          setLoading(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, []);

  return { priceGroupOptions, memberTypeNames, loading };
};

export default useManageOptions;
